export default __webpack_public_path__ + "static/media/w4.3ad714f2.svg";